<template>
  <div class="operation">
    <el-card class="card3" shadow="never">
      <h3>
        <span class="s1">管理员管理</span
        ><span class="s2">可查看所有管理员的中台操作</span>
      </h3>
      <div class="int">
        <!-- 日期组件 -->
        <el-date-picker
          class="rili"
          v-model="value1"
          type="daterange"
          range-separator="→"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <!-- 下拉 -->
        <el-select
          style="width: 146px; margin-left: 16px"
          v-model="select"
          placeholder="请选择"
        >
          <el-option label="全部操作类型" value="1"></el-option>
        </el-select>
        <!-- 按钮 -->
        <el-button style="width: 94px; margin-left: 16px">导出日志</el-button>
        <el-button style="width: 94px; margin-left: 16px">删除日志</el-button>
        <!-- 搜索框 -->
        <el-input
          class="search"
          placeholder="请输入关键词搜索标签"
          suffix-icon="el-icon-search"
          v-model="input2"
        >
        </el-input>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="账号" width="100"> </el-table-column>
        <el-table-column prop="d2" label="操作类型" width="180">
        </el-table-column>
        <el-table-column prop="d3" label="说明"> </el-table-column>
        <el-table-column prop="d4" label="操作时间"> </el-table-column>
        <el-table-column prop="d5" label="登录IP"> </el-table-column>
      </el-table>
       <!-- 分页 -->
      <el-pagination
        class="my-page"
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="prev,pager,next,sizes,jumper"
        :total="70"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //搜索
      input2: "",
      //下拉
      select: "全部操作类型",
      //表格数据
      tableData: [
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
        {
          d1: "丽莎深",
          d2: "登录成功",
          d3: "-",
          d4: "2021-09-09 15:11:55",
          d5: "195.237.220.135",
        },
      ],
      value1:'',
    };
  },
};
</script>

<style lang='less'>
.operation {
  .card3 {
    h3 {
      .s1 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33393f;
      }
      .s2 {
        margin-left: 12px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
      }
    }
    .int {
      margin-top: 47px;
      .search {
        display: inline-block;
        width: 400px;
        margin-left: 16px;
      }
      .el-input--mini {
        font-size: 14px;
      }
    }
    //表格样式
    .el-table {
      margin-top: 20px;
      border: none;
      .el-table__header tr,
      .el-table__header th {
        padding: 0;
        height: 43px;
      }
      .el-table__row {
        height: 52px;
      }
      .cell {
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
     //分页样式
    .my-page {
      margin-top: 15px;
      .el-pager li {
        background-color: #fff;
      }
      .btn-prev {
        background-color: #fff;
      }
      .btn-next {
        background-color: #fff;
      }
      .el-pagination__jump {
        margin-left: 10px;
      }
    }
    // 日期选择器组件样式
    .el-range-editor--mini.el-input__inner {
      width: 222px;
      height: 32px;
    }
    .el-date-editor .el-range-separator {
      padding: 0px 4px;
      line-height: 18px;
      width: 5%;
      color: #c6c8cc;
    }
  }
}
</style>